<template>
  <div class="c-form">
    <div class="d-flex align-items-center mb-4">
      <h2
        class="mb-0 fs-18 w-sbold gray-medium border-pri-left ps-3">
        Contáctanos y te responderemos de inmediato.
      </h2>
    </div>
      <form action="">
        <div class="row">
          <div class="col-12">
            <div
              class="c-form-group mb-4"
              :class="{ 'c-form-group--error': $v.participant.fullname.$error }"
            >
              <input
                class="c-form-group__input--user"
                v-model.trim="$v.participant.fullname.$model"
                placeholder="Ingresa tu nombre"
              />

              <span
                class="c-form-group__error"
                v-if="!$v.participant.fullname.required"
              >
                Nombre es requerido
              </span>
              <span class="c-form-group__error" v-if="!$v.participant.fullname.minLength">
                Nombre debe tener al menos
                {{$v.participant.fullname.$params.minLength.min}} letras.
              </span>
            </div>
          </div>
          <div class="col-12">
            <div
              class="c-form-group mb-4"
              :class="{ 'c-form-group--error': $v.participant.email.$error }"
            >
              <input
                class="c-form-group__input--email"
                v-model.trim="$v.participant.email.$model"
                placeholder="Correo"
                type="email"
              />

              <div class="c-form-group__error" v-if="!$v.participant.email.required">
                Correo es requerido
              </div>
              <div class="c-form-group__error" v-if="!$v.participant.email.alpha">
                No es un email
              </div>
            </div>
          </div>
          <div class="col-12">
            <div
              class="c-form-group mb-4"
              :class="{ 'c-form-group--error': $v.participant.phone.$error }"
            >
              <input
                type="number"
                class="c-form-group__input--phone iconify"
                v-model.trim="$v.participant.phone.$model"
                placeholder="Teléfono"
              />

              <span
                class="c-form-group__error"
                v-if="!$v.participant.phone.required"
              >
                Teléfono es requerido
              </span>
              <span class="c-form-group__error" v-if="!$v.participant.phone.minLength">
                Teléfono debe tener al menos
                {{$v.participant.phone.$params.minLength.min}} números.
              </span>
            </div>
          </div>
          <div class="col-12">
            <div
              class="c-form-group mb-4"
              :class="{ 'c-form-group--error': $v.participant.dni.$error }"
            >
              <input
                type="number"
                class="c-form-group__input--dni iconify"
                v-model.trim="$v.participant.dni.$model"
                placeholder="DNI"
              />

              <span
                class="c-form-group__error"
                v-if="!$v.participant.dni.required"
              >
                DNI es requerido
              </span>
              <span class="c-form-group__error" v-if="!$v.participant.dni.minLength">
                DNI debe tener al menos
                {{$v.participant.dni.$params.minLength.min}} números.
              </span>
            </div>
          </div>
          <div class="col-12">
            <div class="mb-4"
              :class="{ 'c-form-group--error': $v.participant.politics.$error }"
            >
              <div class="d-flex">
                <input
                  type="checkbox"
                  name=""
                  id="politic"
                  class="me-3"
                  v-model.trim="$v.participant.politics.$model"
                >
                <label for="politic" class="gray-medium fs-16 w-regular">
                  Autorizo el tratamiento de mis datos según
                  <a
                    v-if="general && general.data"
                    :href="general.data.information.politics"
                    target="_blank"
                    class="c-link c-link--pri"
                  >
                    políticas y privacidad web
                  </a>
                </label>
              </div>

              <span class="c-form-group__error"
                v-if="!$v.participant.politics.required"
              >
                Es necesario aceptar las Politicas de Privacidad Web
              </span>
            </div>
          </div>

          <div class="col-12">
            <Alert v-if="error" type="danger" :message.sync="error"/>
          </div>

          <div class="col-12">
            <button
              type="button"
              @click="register()"
              :disabled="loading.participant"
              class="c-button c-button--primary w-100 text-center">
              {{ (loading.participant) ? 'Enviando' : 'Enviar'}}
            </button>
          </div>
        </div>
      </form>
  </div>
</template>

<script>
import {
  required,
  minLength,
  helpers,
} from 'vuelidate/lib/validators';
import { mapState, mapActions } from 'vuex';

export default {
  data() {
    return {
      participant: {
        fullname: '',
        phone: '',
        dni: '',
        email: '',
        politics: [],
      },

      error: '',

      loading: {
        participant: false,
      },
    };
  },
  props: {
    contextLoading: Boolean,
  },
  validations: {
    participant: {
      phone: {
        required,
        minLength: minLength(9),
      },
      dni: {
        required,
        minLength: minLength(8),
      },
      email: {
        required,
        alpha: helpers.regex('alpha', /.+@.+\..+/),
      },
      fullname: {
        required,
        minLength: minLength(4),
      },
      politics: {
        required,
      },
    },
  },
  components: {
    Alert: () => import(/* webpackChunkName: "alert" */'@/components/Alert.vue'),
  },
  computed: {
    ...mapState(['general']),

    recaptchaSiteKey() {
      return this.general.data.information.recaptcha_sitekey;
    },
    contactFormId() {
      return this.general.data.information.contact_form_id;
    },
  },
  mounted() {
    this.loadScripts();
  },
  methods: {
    ...mapActions(['form']),

    register() {
      /* eslint-disable */
      this.$v.$touch();

      if (!this.$v.$invalid) {
        this.loading.participant = true;

        grecaptcha.ready(() => {
          grecaptcha.execute(this.recaptchaSiteKey)
            .then(async (token) => {
              const formData = new FormData();
              const API = process.env.VUE_APP_MODE === 'production'
                ? `https://${window.location.hostname}/wp-json/contact-form-7/v1/contact-forms`
                : process.env.VUE_APP_CF_API;


              formData.append('fullname', this.participant.fullname);
              formData.append('dni', this.participant.dni);
              formData.append('phone', this.participant.phone);
              formData.append('email', this.participant.email);
              formData.append('politic', true);
              formData.append('_wpcf7_recaptcha_response', token);

              fetch(`${API}/${this.contactFormId}/feedback`, {
                method: 'POST',
                body: formData,
              })
              .then((res) => {
                if (res.status >= 200 && res.status < 300) {
                  return res.json();
                }

                throw res;
              })
              .then((response) => {
                if (response.status) {
                  // this.sendLeads();
                  this.closeSuccess();
                } else {
                  this.error = response.message;
                }
              })
              .catch((err) => {
                this.error = err.message;
              })
            })
            .catch((err) => {
              this.error = err.message;
            })
        });
      }
      /* eslint-enable */
    },
    sendLead() {
      const request = 'https://vivehogar.com.pe/wp-json/custom/v1/pages/leads';
      const form = new FormData();
      if (window.location.href.toLowerCase().includes('lambayeque')) {
        form.append('recipient', 'p_arica_vive_hogar@evolta.pe');
        form.append('driver', 'evolta');
      } else if (window.location.href.toLowerCase().includes('sullana')) {
        form.append('recipient', 'vive.hogar.sullana@evolta.pe');
        form.append('driver', 'evolta');
      } else if (window.location.href.toLowerCase().includes('castilla')) {
        form.append('driver', 'perfomlead');
        form.append('page_source', window.location.href);
      }

      form.append('source', 'landing');
      form.append('origin', document.title);
      form.append('fullname', this.participant.fullname);
      form.append('lastname', this.participant.fullname);
      form.append('dni', this.participant.dni);
      form.append('phone', this.participant.phone);
      form.append('email', this.participant.email);
      form.append('comentario', 'Sin comentarios');
      form.append('utm_source', 'Landing Web');
      fetch(request, {
        method: 'POST',
        body: form,
      });
    },
    closeSuccess() {
      this.$v.$reset();

      this.participant = {
        fullname: '',
        lastname: '',
        phone: '',
        dni: '',
        proyect: '',
        email: '',
        politics: '',
      };

      this.loading.participant = false;
    },
    loadScripts() {
      const recaptchaScript = document.createElement('script');

      recaptchaScript.setAttribute('src', `https://www.google.com/recaptcha/api.js?render=${this.recaptchaSiteKey}`);

      document.head.appendChild(recaptchaScript);
    },
  },
};
</script>
